export default function(text) {
  const fakeTextarea = document.createElement('textarea');
  const { style } = fakeTextarea;

  style.fontSize = '16px';
  style.border = '0';
  style.padding = '0';
  style.margin = '0';
  style.position = 'absolute';
  style.right = '-9999px';
  style.top = '-9999px';
  fakeTextarea.setAttribute('readonly', '');
  fakeTextarea.value = text;

  document.body.appendChild(fakeTextarea);
  setTimeout(() => document.body.removeChild(fakeTextarea), 1000);

  fakeTextarea.select();
  fakeTextarea.setSelectionRange(0, fakeTextarea.value.length);

  document.execCommand('copy');
}
